import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import { FiArrowLeft, FiAlertCircle } from 'react-icons/fi';
import { IoSchoolOutline } from 'react-icons/io5';

const CatCoursesPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100">
      <Header />

      <main className="max-w-7xl mx-auto px-4 py-6">
        {/* Navigation */}
        <div className="mb-6">
          <button
            onClick={() => navigate('/home')}
            className="flex items-center text-uc-navy hover:text-uc-gold transition-colors mb-4"
          >
            <FiArrowLeft size={20} className="mr-2" />
            Back to Home
          </button>
          <h1 className="text-3xl font-bold text-uc-navy font-header">CAT COURSES</h1>
          <p className="text-gray-600 mt-2">Browse and register for courses</p>
        </div>

        {/* Status Card */}
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="p-8 text-center">
            <div className="flex justify-center mb-6">
              <div className="w-24 h-24 bg-uc-gold bg-opacity-20 rounded-full flex items-center justify-center">
                <IoSchoolOutline className="text-uc-gold" size={48} />
              </div>
            </div>

            <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-2xl mx-auto">
              <div className="flex items-start gap-3">
                <FiAlertCircle className="text-red-600 mt-1 flex-shrink-0" size={24} />
                <div className="text-left">
                  <h2 className="text-xl font-bold text-red-900 mb-2">Registration Closed</h2>
                  <p className="text-red-800">
                    Registration for courses is currently closed.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 max-w-2xl mx-auto text-left">
              <h3 className="font-bold text-uc-navy mb-4">About Cat Courses</h3>
              <div className="space-y-3 text-gray-700">
                <p>
                  Cat Courses is UC Merced's online learning management system powered by Canvas.
                  It provides access to:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Course materials and syllabi</li>
                  <li>Assignments and grades</li>
                  <li>Discussion boards and announcements</li>
                  <li>Online quizzes and exams</li>
                  <li>Collaboration tools and file sharing</li>
                  <li>Communication with instructors and classmates</li>
                </ul>
                <p className="mt-4 text-sm text-gray-600">
                  Course registration periods are announced by the Registrar's Office.
                  Check your email and the academic calendar for upcoming registration dates.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CatCoursesPage;
